import { ArrowSectionSeparator } from 'app/components/shared/ArrowSectionSeparator'
import { useAuth } from 'app/contexts/AuthenticationProvider'
import { useLayout } from 'app/contexts/LayoutProvider'
import React, { useLayoutEffect } from 'react'

import { InputHolderDocumentForm } from '../InputHolderDocumentForm'
import { InputRegistryDocumentForm } from '../InputRegistryDocumentForm'
import { InputRegistryDocumentDownload } from '../RegistryDocumentDownload'

type Props = {
  onRegistrationCompleted: () => void
}
export const DocumentsRegistrationSteps = ({
  onRegistrationCompleted,
}: Props): JSX.Element => {
  const { user } = useAuth()
  const { updateLayoutData } = useLayout()

  useLayoutEffect(() => {
    updateLayoutData({
      title: 'Area sponsor Marketing',
      subTitle: 'Una foto, una firma \n e ci siamo!',
      headerVariant: 'authentication',
    })
  }, [updateLayoutData])

  const hasHolderUploadedFile = !!(
    user?.sponsorman.identity_document_file_name &&
    user?.sponsorman.identity_document_url
  )

  return (
    <>
      <InputHolderDocumentForm isUpdate={hasHolderUploadedFile} />
      {hasHolderUploadedFile && (
        <>
          <ArrowSectionSeparator />
          <InputRegistryDocumentDownload />
          <ArrowSectionSeparator />
          <InputRegistryDocumentForm
            onRegistrationCompleted={onRegistrationCompleted}
          />
        </>
      )}
    </>
  )
}
